import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, debounceTime, takeUntil } from 'rxjs';

@Directive({
  selector: '[appDebounceInput]',
  standalone: true,
})
export class DebounceInputDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 2000;
  @Output() appDebounceInput = new EventEmitter<Event>();

  private input$ = new Subject<Event>();
  private destroy$ = new Subject<void>();
  private skipNext = false;

  ngOnInit() {
    this.input$.pipe(
      debounceTime(this.debounceTime),
      takeUntil(this.destroy$)
    ).subscribe(event => {
      if (this.skipNext) {
        this.skipNext = false;
        return;
      }
      this.appDebounceInput.emit(event);
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    this.input$.next(event);
  }

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: Event) {
    this.skipNext = true;
    this.appDebounceInput.emit(event);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
